import Footer from "../components/footer";
import Login from "../components/login";
import Navbar from "../components/navbar";

function LoginPage() {
  return (
    <>
      <div className="max-w-screen-xl  mx-auto pt-20 flex-col bg-fixed">
        <Navbar />
        <Login />
        <Footer />
      </div>
    </>
  );
}
export default LoginPage;
